<template>
	<div id="logout">
		<div class="text-center">
			<div class="card">
				<div class="card-body p-4 p-sm-5">
					<p class="lead mt-4 text-800 font-sans-serif fw-semi-bold w-md-75 w-xl-100 mx-auto">Estamos cerrando su sesión . . .</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from './mixins'
export default {
	name: 'Logout',
	mixins: [mixin],
	data() {
		return {
		}
	},
	computed: {
	},
	methods: {
	},
	mounted () {
		console.log('Cerrando sesión 	. . .')
		localStorage.removeItem("token")
		setTimeout(()=>{
			console.clear()
			this.$router.push('/login')
		}, 3000)
	},
}	
</script>

<style lang="scss">
</style>
